import { userSettingsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { getActionStatusName, setActionStatusError, setActionStatusPending, setActionStatusSuccess, SET_ACTION_STATUS_ERROR, SET_ACTION_STATUS_PENDING, SET_ACTION_STATUS_SUCCESS } from '@/store/helpers';
import { GET_USER_SETTINGS } from './actionTypes';
import { SET_USER_SETTINGS } from './mutationTypes';

export const state = () => ({
  // user settings here
  status: {},
  userSettings: {}
});


/**
 * @type {import('vuex').ActionTree}
 */
export const actions = {
  async [GET_USER_SETTINGS]({ commit }) {
    commit(SET_ACTION_STATUS_PENDING, { actionName: GET_USER_SETTINGS });
    commit(SET_USER_SETTINGS, {});
    try {
      const userSettings = await userSettingsService.getUserSettings();
      commit(SET_USER_SETTINGS, userSettings);
      commit(SET_ACTION_STATUS_SUCCESS, { actionName: GET_USER_SETTINGS });
    } catch (e) {
      commit(SET_ACTION_STATUS_ERROR, { actionName: GET_USER_SETTINGS, error: e });
    }
  },
};

export const mutations = {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_USER_SETTINGS](state, userSettings) {
    state.userSettings = userSettings;
  },
};

export const getters = {
  getUserSettingsStatus(state) {

    return state.status[getActionStatusName(GET_USER_SETTINGS)] || {}; 
  }
};


export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
};